export default {
  setCanBeOrdered (state, canBeOrdered) {
    state.canBeOrdered = canBeOrdered
  },

  setAllProducts (state, products) {
    state.all = products
  },

  setCategories (state, categories) {
    state.categories = categories
  },

  setCategory (state, category) {
    state.category = category
  },

  setLoading (state, loading) {
    state.loading = loading
  },

  setLoaded (state, loaded) {
    state.loaded = loaded
  },

  setError (state, error) {
    state.error = error
  },

  toggleView (state) {
    state.view = state.view === 'grid' ? 'list' : 'grid'
  },

  setSearch (state, term) {
    state.search = term
  },

  setPriceRange (state, priceRange) {
    state.priceRange = priceRange
  },

  setFilters (state, filters) {
    state.filters = Object.assign({}, state.filters, filters)
  },

  resetFilters (state) {
    state.filters = {
      priceRange: state.priceRange,
      strain: [],
      brand: []
    }
  },

  removeFilterValue (state, filter) {
    if (state.filters.hasOwnProperty(filter.key)) {
      state.filters[filter.key] = state.filters[filter.key].filter(
        v => v !== filter.value
      )
    }
  },

  resetPriceRangeFilter (state) {
    state.filters.priceRange = state.priceRange
  },

  setSortField (state, field) {
    state.sort.field = field
  },

  setSortDirection (state, direction) {
    state.sort.dir = direction
  }
}
